import { Alert, Button, Card, CardBody, CardHeader } from '@heroui/react';
import { Icon } from '@iconify/react';
import dayjs, { Dayjs } from 'dayjs';
import { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';

import { useAppSelector } from '@/redux/hooks';

import { DateModalDischarge } from '../../prompts/DateModal';
import { SetDelivery } from '../../prompts/SetDelivery';

interface PeriopCardMatProps {
  confirmedSurgery: boolean;
  dueDate: Dayjs | null;
  headerText: string;
  startOfDayInHospitalTz: Dayjs | null;
}

export function PeriopCardMat({
  confirmedSurgery,
  dueDate,
  headerText,
  startOfDayInHospitalTz,
}: PeriopCardMatProps) {
  const { t } = useTranslation('home');

  const { dischargePrompt } = useAppSelector((state) => state.app);

  const [dischargeModal, toggleDischargeModal] = useState<boolean>(false);
  const [delayDateModal, toggleDelayDateModal] = useState<boolean>(false);

  const daysAfterSurgery = dayjs(startOfDayInHospitalTz).diff(
    dayjs(dueDate),
    'days'
  );

  useEffect(() => {
    if (!confirmedSurgery) {
      toggleDelayDateModal(true);
    }
  }, [confirmedSurgery, dischargePrompt]);

  return (
    <>
      <SetDelivery
        isOpen={delayDateModal}
        onClose={() => toggleDelayDateModal(false)}
      />
      <DateModalDischarge
        isOpen={dischargeModal}
        onClose={() => toggleDischargeModal(false)}
        title={t('periopcardmat.button.set_discharge_description')}
      />
      <Card shadow="none" className="bg-transparent px-0">
        <CardHeader className="px-0">
          <h1 className="text-2xl">{headerText}</h1>
        </CardHeader>
        <CardBody className="px-0">
          <h2 className="font-light">
            {t('periopcardmat.countdown', { count: daysAfterSurgery })}
          </h2>
          <p className="font-light">{t('periopcardmat.description')}</p>
        </CardBody>
      </Card>
      <Alert
        color="primary"
        description={t('periopcardmat.button.set_surgery_title')}
        icon={<Icon icon="fa-solid:calendar-day" width="20" />}
        hideIconWrapper
        variant="faded"
      >
        <Button
          onPress={() => toggleDelayDateModal(true)}
          className="mt-4"
          color="primary"
          size="sm"
        >
          {t('common.action.update')}
        </Button>
      </Alert>
      <Alert
        color="primary"
        description={t('periopcardmat.button.set_discharge_title')}
        icon={<Icon icon="fa-solid:calendar-day" width="20" />}
        hideIconWrapper
        variant="faded"
      >
        <Button
          className="mt-4"
          color="primary"
          onPress={() => toggleDischargeModal(true)}
          size="sm"
        >
          {t('periopcardmat.button.set_discharge_description')}
        </Button>
      </Alert>
    </>
  );
}
